import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/policies/layout.tsx");
